import React, { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";

type RangeSliderWithInputsProps = {
  label: string;
  value: [number | null, number | null];
  onChange: (value: [number | null, number | null]) => void;
};

export default function RangeSliderWithInputs({
  label,
  value,
  onChange,
}: RangeSliderWithInputsProps) {
  const [localValue, setLocalValue] =
    useState<[number | null, number | null]>(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleInputChange =
    (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const input = event.target.value;
      const newVal = input === "" ? null : Number(input);
      const updated = [...localValue] as [number | null, number | null];
      updated[index] = newVal;
      setLocalValue(updated);
      onChange(updated);
    };

  return (
    <Box width="100%" display="flex" gap={1} alignItems="center">
      <Typography
        variant="caption"
        display="block"
        whiteSpace="nowrap"
        fontSize="16px"
        flexGrow={1}
      >
        {label}
      </Typography>
      <TextField
        label="From"
        type="number"
        value={localValue[0] ?? ""}
        onChange={handleInputChange(0)}
        size="small"
        sx={{ width: "80px" }}
      />
      <TextField
        label="To"
        type="number"
        value={localValue[1] ?? ""}
        onChange={handleInputChange(1)}
        size="small"
        sx={{ width: "70px" }}
      />
    </Box>
  );
}
